import { render } from "./BacklogView.vue?vue&type=template&id=50114449&scoped=true"
import script from "./BacklogView.vue?vue&type=script&lang=js"
export * from "./BacklogView.vue?vue&type=script&lang=js"

import "./BacklogView.vue?vue&type=style&index=0&id=50114449&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50114449"]])

export default __exports__